import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Entity } from '@proman/services/entity.service';
import { resourcesConfig } from '@proman/resources';

const WIDGETS = resourcesConfig.widget.params.widgetTypes;

@Component({
    selector: 'pm-add-widget',
    template: `
        <pro-dialog-title title="add_widget"></pro-dialog-title>
        <div mat-dialog-content>
          <table class="Table">
            @for (widget of widgets; track widget) {
              <tr>
                <td>{{ 'widget_title_' + widget | translate }}</td>
                <td>
                  <pro-btn
                    (onClick)="dialogRef.close(widget)"
                    icon="check-circle"
                  theme="accent"></pro-btn>
                </td>
              </tr>
            }
          </table>
        </div>
        <pro-dialog-actions></pro-dialog-actions>
        `,
    standalone: false
})

export class AddWidgetDialogComponent {
    data = inject(MAT_DIALOG_DATA);
    private Entity = inject(Entity);
    private dialogRef = inject<MatDialogRef<AddWidgetDialogComponent>>(MatDialogRef);

    widgets: any[] = Object.keys(WIDGETS);

}
